module.exports = __webpack_public_path__ + "media/images/hitfun/icon.like.pink-2d5e3eff63a5430d27f667050f7d6b01.svg";